import { render, staticRenderFns } from "./CalendarEdit.vue?vue&type=template&id=5f5d8b87&lang=pug&"
import script from "./CalendarEdit.vue?vue&type=script&lang=js&"
export * from "./CalendarEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports